import { makeStyles } from 'e100-react-components';

export const useStyles = makeStyles(() => ({
  container: {
    overflow: 'hidden',
    height: '100%',
  },
  content: {
    height: '100%',
    overflowY: 'auto'
  }
}));
